import { useTranslation } from "@/Common/CustomHooks/useTranslation";
import { Person } from "@/Common/Models/Person/Person";
import { PersonSimpleInfoDisplay } from "./PersonSimpleInfoDisplay";

import styles from "./DisplayPatientComparison.module.scss";

function DisplayPatientComparison({ patientA, patientB }: Readonly<{ patientA: Person, patientB: Person }>): JSX.Element {
    const { getText } = useTranslation();
    return (
        <div className={styles.displayPatientComparison}>
            <div>
                <label>{getText("PatientMergeRequestPopup_PatientALabel")}</label>
                <PersonSimpleInfoDisplay
                    currentPersonContext={patientB}
                    person={patientA}
                />
            </div>
            <div>
                <label>{getText("PatientMergeRequestPopup_PatientBLabel")}</label>
                <PersonSimpleInfoDisplay
                    currentPersonContext={patientA}
                    person={patientB}
                />
            </div>
        </div>
    );
}

export { DisplayPatientComparison };
